/**
 * @generated SignedSource<<79da29406a095e57c8af554245f83577>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FacebookSettings_settings$data = {
  readonly facebookSettings: {
    readonly accessToken: string | null;
    readonly loginAppId: string | null;
    readonly loginAppSecret: string | null;
    readonly pixelId: string | null;
    readonly testCode: string | null;
  } | null;
  readonly " $fragmentType": "FacebookSettings_settings";
};
export type FacebookSettings_settings$key = {
  readonly " $data"?: FacebookSettings_settings$data;
  readonly " $fragmentSpreads": FragmentRefs<"FacebookSettings_settings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FacebookSettings_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FacebookSettings",
      "kind": "LinkedField",
      "name": "facebookSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pixelId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accessToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "testCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "loginAppId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "loginAppSecret",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Settings",
  "abstractKey": null
};

(node as any).hash = "b88a8fb8fe8e083eb13863d95c0d4166";

export default node;
